const MClient = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'client.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  }
]

const MClientAccounts = [
  {
    title: 'Accounts',
    is_heading: true,
    is_active: false,
    link: {
      name: 'client.accounts'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Users',
    is_heading: false,
    is_active: false,
    link: {
      name: 'client.accounts.users'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-user-visor',
    active_icon: 'fad fa-user-visor'
  }
]

const MClientServices = [
  {
    title: 'Services',
    is_heading: true,
    is_active: false,
    link: {
      name: 'client.services'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Cards',
    is_heading: false,
    is_active: false,
    link: {
      name: 'client.services.cards'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-box-taped',
    active_icon: 'fad fa-box-taped'
  }
]

export default MClient.concat(
  MClientAccounts,
  MClientServices
)
